export { VSlideGroup } from './VSlideGroup'
export { VSlideGroupItem } from './VSlideGroupItem'
